import { graphql } from "@opensea/graphql"
import { ItemCardMediaFragment } from "@/components/items/card/ItemCardMedia/ItemCardMedia.fragment"
import { ItemCardNameFragment } from "@/components/items/card/ItemCardName"
import { RarityBadgeFragment } from "@/components/items/card/RarityBadge"
import { ItemLinkFragment } from "@/components/items/ItemLink"
import { TokenPriceFragment } from "@/components/price/TokenPrice.fragment"

export const ActivityItemCardFragment = graphql(
  `
    fragment ActivityItemCard on Activity {
      eventTime
      item {
        id
        isFungible
        ...ItemCardMedia
        ...ItemCardNameFragment
        ...ItemLink
        ...RarityBadgeFragment
      }
      price {
        ...TokenPrice
      }
    }
  `,
  [
    ItemCardMediaFragment,
    ItemCardNameFragment,
    ItemLinkFragment,
    RarityBadgeFragment,
    TokenPriceFragment,
  ],
)
